import React from 'react'
import { NavigationContainer } from '@src/screens/Common/containers'
import { EhrCoachSpecialty } from '@src/types'
import { AllCoachProfilesQuery } from '@src/graphql/fetchAllCoachProfiles.generated'
import { useLazyScreenPreload } from '@src/navigation/utils'
import { ChooseCoach } from '../NutritionistSwitch/ChooseCoach'

const PER_PAGE = 2

interface SeeAllCoachesProps {
  navigationTitle: string
  title: string
  perPage?: number
  loadMoreButtonText?: string
  onLoadMore?: () => void
  selectedSpecialties?: EhrCoachSpecialty[]
  loadCoachProfiles: ({
    page,
    specialties,
  }: {
    page: number
    specialties: EhrCoachSpecialty[]
  }) => Promise<AllCoachProfilesQuery['allCoachProfiles']>
  onNoCoachesFound?: () => void
  onCoachSelect: (
    coachProfile: AllCoachProfilesQuery['allCoachProfiles']['coachProfiles'][0],
  ) => void
  generateChooseCoachButtonText?: (
    coachProfile: AllCoachProfilesQuery['allCoachProfiles']['coachProfiles'][0],
  ) => string
  showFilters?: boolean
  alertMessage?: string
  onShowFilters?: () => void
}

export const SeeAllCoaches = ({
  navigationTitle,
  title,
  perPage = PER_PAGE,
  loadMoreButtonText,
  onLoadMore,
  selectedSpecialties,
  loadCoachProfiles,
  onNoCoachesFound,
  onCoachSelect,
  generateChooseCoachButtonText,
  showFilters = true,
  alertMessage,
  onShowFilters,
}: SeeAllCoachesProps) => {
  useLazyScreenPreload('CoachSwitchSpecialtiesFilterModal', {
    shouldPreload: showFilters,
  })

  return (
    <NavigationContainer title={navigationTitle}>
      <ChooseCoach
        title={title}
        loadMoreButtonText={loadMoreButtonText}
        onLoadMore={onLoadMore}
        perPage={perPage}
        selectedSpecialties={selectedSpecialties}
        loadCoachProfiles={loadCoachProfiles}
        onNoCoachesFound={onNoCoachesFound}
        onCoachSelect={onCoachSelect}
        generateChooseCoachButtonText={generateChooseCoachButtonText}
        showFilters={showFilters}
        alertMessage={alertMessage}
        onShowFilters={onShowFilters}
      />
    </NavigationContainer>
  )
}
